function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 5,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0.279907C3.2879 0.279907 0.279297 3.28851 0.279297 6.99991C0.279297 10.712 3.2879 13.7206 7 13.7206C10.7107 13.7206 13.72 10.712 13.72 6.99991C13.72 3.28851 10.7107 0.279907 7 0.279907ZM7.6272 2.70611C8.2824 2.70611 8.4749 3.08621 8.4749 3.52091C8.4749 4.06341 8.0409 4.56531 7.2996 4.56531C6.6794 4.56531 6.384 4.25381 6.4022 3.73791C6.4022 3.30321 6.7655 2.70611 7.6272 2.70611ZM5.9486 11.0249C5.5006 11.0249 5.1737 10.7526 5.4866 9.55911L5.9997 7.44161C6.0886 7.10281 6.1033 6.96701 5.9997 6.96701C5.866 6.96701 5.2843 7.20081 4.9413 7.43181L4.718 7.06571C5.8065 6.15641 7.0581 5.62301 7.5936 5.62301C8.0416 5.62301 8.1158 6.15221 7.8925 6.96701L7.3045 9.19301C7.2002 9.58641 7.245 9.72221 7.3493 9.72221C7.4837 9.72221 7.9233 9.55981 8.3559 9.21891L8.6093 9.55911C7.5502 10.6175 6.3959 11.0249 5.9486 11.0249Z",
  fill: "currentcolor"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.2fef98e6.svg";
export { ForwardRef as ReactComponent };